import { getUniversalHelpers } from "../../helpers";
import { Org, OrgId, OrgPaymentPlan, OrgTeamTag } from "@ollie-sports/models";
import { firestoreLiftQuerySubToBifrostSub } from "../../internal-utils/firestoreLiftSubToBifrostSub";

export function orgPaymentPlan__client__getOrgPaymentPlansSubscription(p: { orgId: OrgId }) {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  return firestoreLiftQuerySubToBifrostSub(
    h.OrgPaymentPlan.querySubscription({
      where: [{ orgId: ["==", p.orgId] }]
    })
  );
}
